export default __webpack_public_path__ + "static/media/Snd_6_Starts.33ad5773.mp3";